export const serializeArrayQueryParams = (key: string, arr: Array<string | number | boolean>) => {
	return arr.reduce<string>((prev, arrItem, index) => {
		index === 0 ? (prev += `?${key}=${arrItem}`) : (prev += `&${key}=${arrItem}`);
		return prev;
	}, "");
};
